import React from 'react';
import { Field } from '@sitecore-jss/sitecore-jss-nextjs';
import Texts from '../../../assets/utils/texts';
import { Certification, Training } from 'components/types/ProviderTypes';
import { RichText } from '@sitecore-jss/sitecore-jss-nextjs';

type ProviderBioProps = {
	background: Field<string>;
	specialties?: Array<string>;
	gender: string;
	spokenLanguages: string;
	certifications: Array<Certification>;
	trainings: Array<Training>;
	bio: Field<string>;
};

const ProviderBio = (props: ProviderBioProps): JSX.Element => {
	const { background, gender, spokenLanguages, certifications, trainings, bio, specialties } =
		props;
	return (
		<div id="background" className="provider-background">
			<div className="bg-wrap">
				{background && <h2 className="osf-inner-h2">{Texts.Background}</h2>}
				<div className="bg-top-wrapper">
					<div>
						{specialties && (
							<>
								<p className="osf-nav-section-titles">{Texts.Specialties}</p>
								<ul className="link-list">
									{specialties.map((specialty, index) => {
										return (
											<li key={`specialty-${index}`}>
												<p className="subject-matter-detail">{specialty}</p>
											</li>
										);
									})}
								</ul>
							</>
						)}
						{gender && (
							<>
								<p className="osf-nav-section-titles">{Texts.Gender}</p>
								<ul className="link-list">
									<li>
										<p className="subject-matter-detail">{gender}</p>
									</li>
								</ul>
							</>
						)}
						{spokenLanguages && (
							<>
								<p className="osf-nav-section-titles">{Texts.Languages}</p>
								<ul className="link-list">
									<li>
										<p className="subject-matter-detail">{spokenLanguages}</p>
									</li>
								</ul>
							</>
						)}
					</div>

					<div>
						{certifications && (
							<>
								<p className="osf-nav-section-titles">{Texts.BoardCertifications}</p>
								<ul className="link-list">
									{certifications.map((certification, index) => {
										return (
											<li key={`certification-${index}`}>
												{certification?.fields?.SpecialtyName?.value && (
													<p className="subtitle">{certification?.fields?.SpecialtyName?.value}</p>
												)}
												<p className="subject-matter-detail">
													{certification?.fields?.BoardName?.value &&
														certification?.fields?.BoardName?.value}
													{certification?.fields?.YearCertified?.value &&
														`, ${certification?.fields?.YearCertified?.value}`}
												</p>
											</li>
										);
									})}
								</ul>
							</>
						)}
						{trainings && (
							<>
								<p className="osf-nav-section-titles">{Texts.EducationAndExperience}</p>
								<ul className="link-list">
									{trainings.map((training, index) => {
										return (
											<li key={`training-${index}`}>
												{training?.fields?.TrainingName?.value && (
													<p className="subtitle">{training?.fields?.TrainingName?.value}</p>
												)}
												<p className="subject-matter-detail">
													{training?.fields?.TrainingType?.value &&
														training?.fields?.TrainingType?.value}
													{training?.fields?.FieldOfStudy?.value &&
														`, ${training?.fields?.FieldOfStudy?.value}`}
													{training?.fields?.GraduationYear?.value &&
														`, ${training?.fields?.GraduationYear?.value}`}
												</p>
											</li>
										);
									})}
								</ul>
							</>
						)}
					</div>
				</div>
				{background && (
					<div className="paragraph-intro">
						<RichText field={background} />
					</div>
				)}
				{bio && (
					<div className="biography-text">
						<RichText field={bio} />
					</div>
				)}
			</div>
		</div>
	);
};

export default ProviderBio;
